import { render, staticRenderFns } from "./DeliveryDashboard.vue?vue&type=template&id=64506784&"
import script from "./DeliveryDashboard.vue?vue&type=script&lang=js&"
export * from "./DeliveryDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports